/*globals is_standalone, isChain, emailBID, emailUserId, userEmail*/

import $ from 'jquery';
import _ from 'underscore';
import Rollbar from './rollbar';
import security from 'src/common/security';
const warn = typeof console.warn === 'function' ? console.warn : console.log;

function getCurrentBranchFromDom() {
    var currentBranchToken = getCurrentBranchToken();
    var businessData = $('body').data('features') || {};

    return businessData[currentBranchToken] || {};
}

/**
 * Try to get sak1 status off the dom. Specifically return undefined if it is not found.
 *
 * @returns {*}
 */
function getIsSak1FromDom() {
    var currentBusiness = $('#selectedBusiness').data('token');
    var businessData = $('body').data('features') || {};

    if (
        typeof businessData[currentBusiness] === 'undefined' ||
        typeof businessData[currentBusiness].standalone_k1 === 'undefined'
    ) {
        return;
    }

    return businessData[currentBusiness].standalone_k1 === '1';
}

/**
 * Get the chain or "top level" businesses token.
 *
 * Boutiques and sak1 should return the same value as {@link getCurrentTopLevelToken}.
 *
 * @return {string}
 */
export const getCurrentTopLevelToken = function () {
    return $('#selectedBusiness').data('token');
};

/**
 * Get the branch token for we are currently dealing with.
 * Only relevant to pre-react branch based pages for example appointment book,
 * typically they have a branch selector towards the top left of the screen.
 *
 * Boutiques and sak1 should return the same value as {@link getCurrentTopLevelToken}.
 *
 * @return {string}
 */
export const getCurrentBranchToken = function () {
    const currentBranchToken = $('#selectedBusinessId').html();

    if (!currentBranchToken) {
        warn('WARNING: Attempted to lookup current business location id, was not set');
    }

    return currentBranchToken;
};

export const setCurrentBranchToken = function (token) {
    const $currentBranchToken = $('#selectedBusinessId');

    if ($currentBranchToken.length < 1) {
        warn(
            'WARNING: Attempted to set current business location id, could not find store element #selectedBusinessId'
        );
    } else {
        $currentBranchToken.html(token);
    }
};

export const getBusinessCountry = function () {
    var currentBusiness = $('#selectedBusiness').data('token');
    var businessFeatures = $('body').data('features');
    return businessFeatures[currentBusiness].country;
};

export const getRequiredKitombaVersion = function () {
    return window.required_kitomba_version; //pulled from php template
};

/**
 * Run through various places sak1 status is stored and try to retrieve it.
 *
 * @returns {*}
 */
export const isStandalone = function () {
    var locations = [window.is_standalone, window.standaloneK1, getIsSak1FromDom()];

    for (var i = 0; i < locations.length; i++) {
        if (typeof locations[i] !== 'undefined') {
            return locations[i];
        }
    }

    Rollbar.error(new Error('missing standalone variable'));
    console.error("Can't determine standalone status. Defaulting to false");
    return false;
};

export const isBoutique = function () {
    return !isStandalone() && !isChain();
};

/**
 * Run through various places sak1 status is stored and try to retrieve it.
 *
 * @returns {*}
 */
export const currentBranchKitombaVersion = function () {
    return Number(getCurrentBranchFromDom().kitomba_version);
};

export const getFeatures = function () {
    return $('body').data('features');
};

export const getFeaturesChain = function () {
    return _.findWhere(getFeatures(), { type: 'chain' });
};

export const getFeaturesBusiness = function (businessToken) {
    return _.findWhere(getFeatures(), { token: businessToken });
};

export const getBusinessName = function () {
    return getCurrentBranchFromDom().name;
};

export const getBusinessIsClosedByToken = function (token) {
    return (getFeaturesBusiness(token) || {}).is_closed;
};

export const getBusinessNameByToken = function (token) {
    return (getFeaturesBusiness(token) || {}).name;
};

export const emailBID = function () {
    return window.emailBID;
};

export const emailUserId = function () {
    return window.emailUserId;
};

export const userEmail = function () {
    return window.userEmail;
};

export const isChain = function () {
    if (typeof window.isChain === 'boolean') {
        return window.isChain;
    }

    //Chains should have at least two feature bags (1 chain, 1 branch) even if there is only has one branch.
    var features = $('body').data('features');
    if (typeof features === 'object') {
        return Object.keys(features).length > 1;
    }

    return false;
};

export const getBusinessDetails = function (business_token) {
    var business_details_url = '/k1/settings_ajax/getBusinessDetails';

    return $.ajax({
        url: business_details_url,
        data: { business_token: business_token },
        dataType: 'json',
        type: 'POST',
    });
};

export const getKmailUserTemplateList = function (business_token) {
    var kmailTemplateList_url = '/k1/settings_ajax/getKmailUserTemplateList';

    return $.ajax({
        url: kmailTemplateList_url,
        data: { business_token: business_token },
        dataType: 'json',
        type: 'POST',
    });
};

export const getDefaultBusinessUnit = function (business_token) {
    var business_unit_url = '/k1/settings_ajax/getDefaultBusinessUnit';

    return $.ajax({
        url: business_unit_url,
        data: { business_token: business_token },
        dataType: 'json',
        type: 'POST',
    });
};

export const getBusinessAndBusinessUnitDetails = function () {
    return $.when(
        getDefaultBusinessUnit(getCurrentBranchToken()),
        getBusinessDetails(getCurrentBranchToken())
    ).then(function (bUnit, bDetails) {
        return [bUnit[0], bDetails[0]];
    });
};

/**
 * Get branch list. A boutique will return a list of just the boutique
 * (unless excluded by the optional permission filter)
 *
 * @param [permission] Optional permission constant to filter for
 * @returns {unknown[]}
 */
export const getBranches = function (permission) {
    let branches = Object.values(getFeatures())
        .filter((branch) => branch.type !== 'chain')
        .sort((a, b) => a.name - b.name);

    if (permission) {
        branches = branches.filter((branch) => security.check(branch.token, permission));
    }

    return branches;
};

/**
 * Get branch info by token
 *
 * @param businessToken
 * @param permission
 * @returns {*}
 */
export const getBranch = function (businessToken, permission) {
    return getBranches(permission).find((branch) => branch.token === businessToken);
};

/**
 * Get the first available branch satisfying a permission with an optional indicated preference.
 * With no parameters, will pick the first branch (standard default branch)
 *
 * @param preferredToken Optional business token to prefer if it satisfies the given permission
 * @param permission Optional permission to filter for
 * @returns {*}
 */
export const getDefaultBranch = function (preferredToken, permission) {
    const availableBranches = getBranches(permission);
    const requestedBranch = availableBranches.find((branch) => branch.token === preferredToken);

    return requestedBranch ?? availableBranches[0];
};

const module = {
    getCurrentTopLevelToken: getCurrentTopLevelToken,
    getCurrentBranchToken: getCurrentBranchToken,
    setCurrentBranchToken: setCurrentBranchToken,
    getBusinessCountry: getBusinessCountry,
    getRequiredKitombaVersion: getRequiredKitombaVersion,
    isStandalone: isStandalone,
    isBoutique: isBoutique,
    currentBranchKitombaVersion: currentBranchKitombaVersion,
    getFeatures: getFeatures,
    getFeaturesChain: getFeaturesChain,
    getFeaturesBusiness: getFeaturesBusiness,
    getBusinessName: getBusinessName,
    getBusinessIsClosedByToken: getBusinessIsClosedByToken,
    getBusinessNameByToken: getBusinessNameByToken,
    emailBID: emailBID,
    emailUserId: emailUserId,
    userEmail: userEmail,
    isChain: isChain,
    getBusinessDetails: getBusinessDetails,
    getKmailUserTemplateList: getKmailUserTemplateList,
    getDefaultBusinessUnit: getDefaultBusinessUnit,
    getBusinessAndBusinessUnitDetails: getBusinessAndBusinessUnitDetails,
    getBranches,
    getBranch,
    getDefaultBranch,
};

export default module;
